import { defineComponent as _defineComponent } from 'vue'
import { computed, ref, watch, nextTick } from 'vue'
  import HTMLRenderer from '@/components/common/HTMLRenderer.vue'
  import useEditor from '@/composables/useEditor'
  import type { PropType } from 'vue'
  import type { LeuckentextQuestionItem } from '@/services/interfaces/Course'
  import { useRoute } from 'vue-router/composables'

  
export default /*#__PURE__*/_defineComponent({
  __name: 'LeuckentextQuestionItem',
  props: {
    item: {
      required: true,
      type: Object as PropType<LeuckentextQuestionItem>,
    },
    selectedAnswer: {
      type: String,
      default: '',
    },
    inResultsMode: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['on-answer-drag-start', 'drag-end', 'reset-answer'],
  setup(__props, { emit }) {

const props = __props;

  
  

  const route = useRoute()
  const { decodeAndParseSource } = useEditor(route)

  const liElement = ref<HTMLElement | null>(null)

  const question = computed(() => {
    const decodedText = decodeAndParseSource(props.item.text)
    const textMatch = decodedText.match(/{{.*}}/)
    return decodedText.replace(/{{.*}}/, () => {
      return `<span class="fill-in ${setFillInClass.value}"><span></span><span class="answer">${
        props.inResultsMode ? textMatch?.[0].replace(/[{}]/g, '') || '' : props.selectedAnswer
      }</span></span>`
    })
  })

  const setFillInClass = computed(() => {
    if (props.inResultsMode) return 'selected results-mode'
    if (props.selectedAnswer) return 'selected'
    return ''
  })

  watch(
    question,
    () => {
      nextTick(() => onSpanClick())
    },
    { immediate: true },
  )

  const onSpanClick = () => {
    if (liElement.value) {
      const fillInSpan = liElement.value.querySelector('.fill-in.selected') as HTMLSpanElement
      if (fillInSpan) {
        fillInSpan.draggable = !props.inResultsMode
        fillInSpan.addEventListener('dragstart', onAnswerDragStart)
        fillInSpan.addEventListener('dragend', onAnswerDragEnd)
        fillInSpan.addEventListener('click', onAnswerClick)
      }
    }
  }

  const onAnswerDragStart = () => {
    emit('on-answer-drag-start', props.item.id)
  }

  const onAnswerDragEnd = () => {
    emit('drag-end')
  }

  const onAnswerClick = () => {
    if (props.inResultsMode) return
    emit('reset-answer', props.item.id)
  }

return { __sfc: true,props, emit, route, decodeAndParseSource, liElement, question, setFillInClass, onSpanClick, onAnswerDragStart, onAnswerDragEnd, onAnswerClick, computed, ref, watch, nextTick, HTMLRenderer, useEditor, useRoute }
}

})